var fetchConfig2 = {
  method: "POST",
  headers: { "Content-Type": "application/json", Accept: `application/json` },
};
const config2 = {
  method: "POST",
  headers: {
    Accept: "application/javascript",
    "X-Requested-With": "XMLHttpRequest",
  },
};
if (typeof Gwp === "undefined") {
  const { FoxThemeStyles, FoxThemeScripts } = window;
  class Gwp {
    constructor() {
      this.modal = null; 
      this.money_format = window.FoxThemeSettings.money_format;
      this.cartDrawer = document.querySelector("cart-drawer");
      this.mainCart = document.querySelector("cart-items");     
      if(window.FoxThemeSettings.gwp_direct){
        fetch(`${FoxThemeSettings.routes.cart}`, {
          ...fetchConfig2
          })
          .then((response) => {
            return response.json();
          })
          .then((cart) => {
            var check_id = window.FoxThemeSettings.gwp_product;
            var hasFreeProduct = cart.items.filter((item) => {
              return item.properties && item.product_id == check_id && item.properties._gwp_product == "true";
            });
            if(window.FoxThemeSettings.GwpEnable && window.FoxThemeSettings.gwp_direct && hasFreeProduct.length == 0 && cart.total_price > window.FoxThemeSettings.gwp_threshold){
              var formData = new FormData();
              // Adding the necessary data to FormData
              if (this.cartDrawer) {
                formData.append(
                  "sections",
                  this.cartDrawer.getSectionsToRender().map((section) => section.id)
                );
              }
              if (this.mainCart) {
                formData.append(
                  "sections",
                  this.mainCart
                    .getSectionsToRender()
                    .map((section) => section.section)
                );
              }
              formData.append('form_type', 'product');
              formData.append('properties[_gwp_product]', 'true'); // Assuming _gwp_product needs to be true
              formData.append('id', window.FoxThemeSettings.gwp_direct_add_id); 
              formData.append('sections_url', '/cart');
              this.addFreeProduct(formData,null)
            }
            else if(hasFreeProduct.length && cart.total_price < window.FoxThemeSettings.gwp_threshold){
              this.removeFreeProduct(hasFreeProduct);
            } 
            else if(hasFreeProduct.length && window.FoxThemeSettings.GwpEnable == false){
              this.removeFreeProduct(hasFreeProduct);
            }
          })
          return
      }
      else if(window.FoxThemeSettings.GwpEnable || window.FoxThemeSettings.multi_prod_gwp){
        this.gwpOpen();
      }
      else{
        this.GwpFunctionality();
      }
    }

    gwpClose(){
      if(this.modal.querySelectorAll('#ModalClose-Gwp')){
       this.modal.querySelectorAll('#ModalClose-Gwp').forEach((close)=>{
         close.addEventListener('click',(e)=>{
           this.modal.remove();
           document.body.classList.remove('prevent-scroll')    
           document.cookie = "gwp_popup=true; path=/; max-age=" + (60 * 60 * 24 * 7);
         })
       })
      }
      $('body').on('click',function(e){
        if(!$(e.target).closest('.f-modal__content').length){
          // console.log('outside click')
          // $('body').removeClass('custom-size-selection-shown');
        }
      })
    }
    
    gwpOpen(){
      fetchSection("gwp-popup")
      .then((html) => {
        this.modal = html.querySelector("modal-dialog");
        this.GwpFunctionality();
        if (document.querySelector("modal-dialog.f-modal-gwp")) return;
        // document.body.appendChild(this.modal);
        this.gwpClose();
        this.GwpCustomDropOpen();        
      })
    }

    GwpFunctionality(){
      fetch(`${FoxThemeSettings.routes.cart}`, {
      ...fetchConfig2
      })
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        var hasFreeProduct = [];
        hasFreeProduct = cart.items.filter((item) => {
              return item.properties && item.properties._gwp_product == "true";
         });
        var cart_total = cart.total_price;
        if (window.FoxThemeSettings.GwpEnable && window.FoxThemeSettings.multi_prod_gwp == false) {
          var check_id = window.FoxThemeSettings.gwp_product;
          if (window.FoxThemeSettings.gwp_type == 'product_select') {
            var found = false;
            var hasGwp = cart.items.filter((item) => {
              return item.product_id == check_id;
            });
            hasFreeProduct = cart.items.filter((item) => {
              return item.properties && item.product_id == check_id && item.properties._gwp_product == "true";
            });
            for (let index = 0; index < window.FoxThemeSettings.gwp_eligible_prods.length; index++) {
              const element = window.FoxThemeSettings.gwp_eligible_prods[index];
              found = cart.items.filter((c) => { return c.handle == element.handle });
              if (found.length > 0) {
                break;
              }
            }
            if (window.FoxThemeSettings.gwp_product_sku != '') {
              //if there is Single variants for GWP popup, so gwp should auto add to cart
              // console.log('found',found,'hasFreeProduct',hasFreeProduct)
              if (found.length > 0 && hasFreeProduct.length == 0) { 
                document.body.appendChild(this.modal);
                this.AtcClick(null,true,null)
              }
              else if (found.length == 0 && hasFreeProduct.length > 0) {
                //removeGWP from cart if no eligible product found       
                this.removeFreeProduct(hasFreeProduct);
              }
            }
            else {
              //if there is multi variants for GWP popup
              if (found.length > 0 && hasFreeProduct.length == 0 && window.FoxThemeSettings.gwp_product_sku == '') {
                document.body.appendChild(this.modal);
                this.AtcClick(null,true,null);
              }
              else if (found.length == 0 && hasFreeProduct.length > 0) {
                //removeGWP from cart if no eligible product found
                this.removeFreeProduct(hasFreeProduct);
              }
            }     
           
          }
          else{      
              if(hasFreeProduct.length == 0 && cart_total > window.FoxThemeSettings.gwp_threshold && window.FoxThemeSettings.gwp_direct == false){
                document.body.appendChild(this.modal);
                this.AtcClick(null,true,true);
              } 
              else if(hasFreeProduct.length == 0 && cart_total < window.FoxThemeSettings.gwp_threshold && window.FoxThemeSettings.gwp_direct == false){   
                document.body.appendChild(this.modal);
                this.AtcClick(true,null,null,cart_total);
              }  
              else if(hasFreeProduct.length && cart_total < window.FoxThemeSettings.gwp_threshold){
                console.log('here in')
                this.removeFreeProduct(hasFreeProduct);
              }
          }
        }
        else if(window.FoxThemeSettings.multi_prod_gwp && window.FoxThemeSettings.GwpEnable == false){
          this.multiPopupCustomChange();
          if(hasFreeProduct.length == 0 && cart_total > window.FoxThemeSettings.multi_thresold){
            document.body.appendChild(this.modal);
            var multi = true;
            this.AtcClick(null,null,null,cart_total,multi)            
          }
          else if(hasFreeProduct.length > 0 && cart_total < window.FoxThemeSettings.multi_thresold){
            this.removeFreeProduct(hasFreeProduct);
          }
        }  
        else if(window.FoxThemeSettings.GwpEnable == false && window.FoxThemeSettings.multi_prod_gwp == false && hasFreeProduct.length){
          this.removeFreeProduct(hasFreeProduct);
        }
      })
    }
    
    multiPopupCustomChange(){
      $('body').on('change','.offer-wrapper input',function(){
        var id = $('.offer-wrapper input:checked').val();
         $('form#gwp-form input[name="id"]').val(id);
      })
    }

    GwpCustomDropOpen(){
      $('body').on('click','.custom-size-selection-toggle',function(e){
        $('body').addClass('custom-size-selection-shown');
        $('.offer-wrapper').removeClass('offer-active');
        $(this).parents('.offer-wrapper').addClass('offer-active');
      })
      $('body').on('click',function(e){
        if(!$(e.target).closest('.custom-size-selection-toggle').length){
           $('body').removeClass('custom-size-selection-shown');
        }
      })
      $('body').on('click','.custom-size-overlay-options button',function(e){
        e.preventDefault();
        $(".custom-size-overlay-options button").removeClass("selected");
        var id = $(this).data('value');
        $(this).addClass("selected");
        var sizeNo = $(this).attr("data-size-no"),
        sizeText = $(this).data("text");
        var sizeLable = sizeNo.length ? `${sizeText} ${sizeNo}` : `${sizeText}`;
        $(this).parents('.pro_variant').find(".custom-size-selection-toggle").text(sizeLable);
        $("body").removeClass("custom-size-selection-shown");
        $('form#gwp-form input[name="id"]').val(id);
      });
    }

    AtcClick(before=null,current=null,after=null,cart_total=null,multi=false){
      var gwpCookieExists = document.cookie.split('; ').find(row => row.startsWith('gwp_popup=')),
        isCartPage = window.location.pathname === '/cart';
      console.log('gwpCookieExists',gwpCookieExists,'isCartPage',isCartPage)
      if(isCartPage || (!gwpCookieExists && !isCartPage)){
        window.dispatchEvent(new CustomEvent(PUB_SUB_EVENTS.cartClose));
        document.body.classList.add('prevent-scroll')  
        this.modal.setAttribute('open','')
      }
      if(multi == false){
        if(current){
          this.modal.querySelector('.gwp_model_main.content_pro').classList.add('show')          
        }
        if(before){
          var spend = window.FoxThemeSettings.gwp_threshold - cart_total;
          var text =  $('div.prequalify-msg').html(); // Use .html() to get the HTML content
          $('div.prequalify-msg').html(text.replace(/XX/g, `<span class="spend">${formatMoney(spend,this.money_format)}</span>`)); // Use .html() to set HTML content
          this.modal.querySelector('.gwp_model_main.before_content').classList.add('show')  
        }
      }
      else{ 
        if(isCartPage || (!gwpCookieExists && !isCartPage)){
          this.modal.querySelector('.gwp_model_main.multi-popup').classList.add('show')           
        }
      }
      this.modal.querySelector('.gwp_atc').addEventListener('click',(e)=>{
        var form = this.modal.querySelector('#gwp-form')
        if($('form#gwp-form input[name="id"]').val() == ''){
          alert('Please select a size')
          return
        }
        e.target.parentNode.classList.add('btn--loading')
        const formData = new FormData(form);
        if (this.cartDrawer) {
          formData.append(
            "sections",
            this.cartDrawer.getSectionsToRender().map((section) => section.id)
          );
        }
        if (this.mainCart) {
          formData.append(
            "sections",
            this.mainCart
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }
        if (this.mainCart || this.cartDrawer) {
          formData.append("sections_url", window.location.pathname);
        }
        this.addFreeProduct(formData,after)
      })
    }

    addFreeProduct(formData,after=null){
      config2.body = formData;
        const { FoxThemeSettings, FoxThemeStrings } = window;
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config2)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
            }
            if(window.FoxThemeSettings.display_gwp == false) return

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }
            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }
            this.error = false;
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            try{
              this.modal.remove();
              this.modal.querySelector('.gwp_atc').classList.remove('btn--loading')
            }catch(e){}
             document.body.classList.remove('prevent-scroll')  
          });
    }

    removeFreeProduct(hasFreeProduct){
      const formData = new FormData();
      if (this.cartDrawer) {
          formData.append(
            "sections",
            this.cartDrawer.getSectionsToRender().map((section) => section.id)
          );
        }
        if (this.mainCart) {
          formData.append(
            "sections",
            this.mainCart
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }
        if (this.mainCart || this.cartDrawer) {
          formData.append("sections_url", window.location.pathname);
        }

      // Add required cart update fields
      formData.append("quantity", 0);   // or your dynamic value
      formData.append("id", hasFreeProduct[0].key);  
      config2.body = formData;
      if(window.FoxThemeSettings.display_gwp == false){
        fetch('/cart/change.js', config2)
        .then(res => res.json())
        .then((response) => {
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
        })
      }else{
         if(document.querySelector(`#CartDrawer`)){
         // var index = document.querySelector(`#CartDrawer [data-id='${hasFreeProduct[0].id}']`).dataset.index;
          document.querySelector(`#CartDrawer [data-cart-item='${hasFreeProduct[0].key}'] .f-cart-drawer__remove`).click()
        }
        if(document.querySelector(`#main-cart-items`)){
          // var index = document.querySelector(`#CartDrawer [data-cart-item='${hasFreeProduct[0].id}']`).dataset.index;
          document.querySelector(`#main-cart-items [data-cart-item='${hasFreeProduct[0].key}'] .f-cart-item__remove-btn`).click()                  
        }
        document.body.classList.remove('prevent-scroll')    
        try{
          this.modal.remove();
        }catch(e){}
      }
    }  
  }
  new Gwp();
  window.Gwp = Gwp;
}